module.exports = __webpack_public_path__ + "img/logo-white.60568a1d.svg";